var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "CUSIP",
            "error-text": _vm.showValidations ? _vm.validations.cusip : "",
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.cusip,
              callback: function ($$v) {
                _vm.cusip = $$v
              },
              expression: "cusip",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Description",
            "error-text": _vm.showValidations
              ? _vm.validations.description
              : "",
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.description,
              callback: function ($$v) {
                _vm.description = $$v
              },
              expression: "description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Add New Trading Product")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }